import { Skeleton, SkeletonGroup } from '@leanin/ui';
import styles from './LoadingState.module.css';

type Props = {
  /** Number of skeleton "rows" (cards) to render. Default 3. */
  rows?: number;
  /** Accessible status text announced by screen readers. */
  label?: string;
  className?: string;
};

/**
 * Generic list-shaped loading placeholder. Use as the fallback while a
 * list-shaped read is in flight when no entity-specific skeleton exists.
 * Pages with a richer layout (e.g. a hero + tabs) should prefer the
 * matching entity skeleton (e.g. `CircleCardSkeleton`) for the list
 * portion and compose page chrome around it.
 */
export const LoadingState = ({ rows = 3, label = 'Loading', className }: Props) => (
  <SkeletonGroup
    label={label}
    className={[styles.root, className ?? ''].filter(Boolean).join(' ')}
  >
    {Array.from({ length: rows }, (_, i) => (
      <article key={i} className={styles.card}>
        <header className={styles.cardHeader}>
          <Skeleton width={44} height={44} rounded="full" />
          <div className={styles.cardHeaderText}>
            <Skeleton width="40%" height={14} />
            <Skeleton width="55%" height={12} />
          </div>
        </header>
        <Skeleton width="92%" height={14} />
        <Skeleton width="88%" height={14} />
        <Skeleton width="70%" height={14} />
      </article>
    ))}
  </SkeletonGroup>
);
